<template>
  <div class="contract-date-time-picker">
    <v-menu
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      :disabled="disabled"
    >
      <template slot="activator" slot-scope="{ on }">
        <v-text-field
          v-on="on"
          :value="dateValue"
          :label="dateLabel"
          prepend-icon="event"
          readonly
          :disabled="disabled"
          :hide-details="hideDetails"
        ></v-text-field>
      </template>
      <v-date-picker
        :value="dateValue"
        color="primary"
        no-title
        scrollable
        @input="selectDate"
      ></v-date-picker>
    </v-menu>

    <v-menu
      v-model="timeMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      :disabled="disabled"
    >
      <template slot="activator" slot-scope="{ on }">
        <v-text-field
          v-on="on"
          :value="timeValue"
          :label="timeLabel"
          prepend-icon="access_time"
          readonly
          :disabled="disabled"
          :hide-details="hideDetails"
        ></v-text-field>
      </template>
      <v-time-picker
        :value="timeValue"
        format="24hr"
        color="primary"
        scrollable
        @input="selectTime"
        @change="completeTimeSelection"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ContractDateTimePicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "กำหนดการ",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateMenu: false,
      timeMenu: false,
    };
  },
  computed: {
    parsedValue() {
      const parsed = moment(this.value, moment.ISO_8601, true);
      return parsed.isValid() ? parsed : null;
    },
    dateValue() {
      return this.parsedValue ? this.parsedValue.format("YYYY-MM-DD") : "";
    },
    timeValue() {
      return this.parsedValue ? this.parsedValue.format("HH:mm") : "";
    },
    dateLabel() {
      return this.label + " - วันที่";
    },
    timeLabel() {
      return this.label + " - เวลา";
    },
  },
  watch: {
    dateMenu(isOpen) {
      if (isOpen) this.timeMenu = false;
    },
    timeMenu(isOpen) {
      if (isOpen) this.dateMenu = false;
    },
  },
  methods: {
    selectDate(date) {
      this.emitDateTime(date, this.timeValue || "00:00");
      this.dateMenu = false;
    },
    selectTime(time) {
      this.emitDateTime(
        this.dateValue || moment().format("YYYY-MM-DD"),
        time
      );
    },
    completeTimeSelection(time) {
      this.selectTime(time);
      this.timeMenu = false;
    },
    emitDateTime(date, time) {
      const value = moment(date + " " + time, "YYYY-MM-DD HH:mm", true);
      if (value.isValid()) {
        this.$emit("input", value.format("YYYY-MM-DDTHH:mm:ss"));
        this.$emit("change", value.format("YYYY-MM-DDTHH:mm:ss"));
      }
    },
  },
};
</script>

<style scoped>
.contract-date-time-picker {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 12px;
  width: 100%;
}

@media (max-width: 600px) {
  .contract-date-time-picker {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }
}
</style>
